import React, { createContext, useContext, useState, useEffect } from 'react';

const ProfilePictureContext = createContext();

export function useProfilePicture() {
  return useContext(ProfilePictureContext);
}

export function ProfilePictureProvider({ children }) {
  const [profilePicture, setProfilePicture] = useState(null);

  // Load from localStorage on mount
  useEffect(() => {
    // Get the current user ID from a global variable or window object
    // This will be set by the layouts when they mount
    const currentUserId = window.currentUserId;
    if (currentUserId) {
      const savedProfilePicture = localStorage.getItem(`profilePicture_${currentUserId}`);
      if (savedProfilePicture) {
        setProfilePicture(savedProfilePicture);
      }
    }
  }, []);

  // Listen for user changes
  useEffect(() => {
    const handleUserChange = (event) => {
      const newUserId = event.detail.userId;
      window.currentUserId = newUserId;
      
      if (newUserId) {
        const savedProfilePicture = localStorage.getItem(`profilePicture_${newUserId}`);
        if (savedProfilePicture) {
          setProfilePicture(savedProfilePicture);
        } else {
          setProfilePicture(null);
        }
      }
    };

    window.addEventListener('userChanged', handleUserChange);
    return () => window.removeEventListener('userChanged', handleUserChange);
  }, []);

  // Save to localStorage whenever it changes, keyed by user ID
  const updateProfilePicture = (newPicture) => {
    setProfilePicture(newPicture);
    const currentUserId = window.currentUserId;
    if (currentUserId) {
      if (newPicture) {
        localStorage.setItem(`profilePicture_${currentUserId}`, newPicture);
      } else {
        localStorage.removeItem(`profilePicture_${currentUserId}`);
      }
    }
  };

  return (
    <ProfilePictureContext.Provider value={{
      profilePicture,
      setProfilePicture: updateProfilePicture
    }}>
      {children}
    </ProfilePictureContext.Provider>
  );
}
